import React from 'react';
import RaisedButton from 'material-ui/FlatButton';
import { Link } from 'react-router-dom';
import { translate } from 'admin-on-rest';
import { stringify } from 'query-string';

const LinkToRelatedQuestions = ({ record, translate }) => (
    <RaisedButton
        primary={true}
        label="ΕΡΩΤΗΣΕΙΣ"
        containerElement={<Link
            to={{
                pathname: '/questions',
                search: stringify({ page: 1, perPage: 10, filter: JSON.stringify({ survey: record.id }) }),
            }}
        />}
    />
);

export default translate(LinkToRelatedQuestions);



// WEBPACK FOOTER //
// ./src/pages/custom/LinkToRelatedQuestions.js